import listRoutes from '@/api/list-routes';
import PublicAPI from '@/api/api-public';
import Api from '@/api/api-admin';
import router from '@/router';

let clientInStorage = sessionStorage.getItem('clients');
if (clientInStorage) {
    try {
        const parsed = JSON.parse(clientInStorage);
        clientInStorage = Array.isArray(parsed) ? parsed : (parsed?.items ?? null);
    } catch (e) {
        clientInStorage = null;
    }
} else {
    clientInStorage = null;
}

let clientsCmsInStorage = sessionStorage.getItem('clients');
if (clientsCmsInStorage && clientsCmsInStorage[0] === "[") clientsCmsInStorage = JSON.parse(clientsCmsInStorage);
else clientsCmsInStorage = null

const state = {
    clients: clientInStorage,
    clientsCms: clientsCmsInStorage,
    client: null,
    clientsMarkets: {}
}

const mutations = {
    SET_CLIENTS(state, clients) {
        state.clients = clients.sort((a, b) => {
            const nameA = a.name.toUpperCase();
            const nameB = b.name.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        });
    },
    SET_CLIENT(state, client) {
        state.client = {...client}
    },
    SET_CLIENT_MARKETS(state, data) {
        state.clientsMarkets[data.client] = data?.market
    },
    SET_CLIENTS_CMS(state, data) {
        state.clientsCms = data;
    }
}

const actions = {
    getClients({commit}) {
        Api.get(listRoutes.clients+"?page=1&limit=999")
            .then(res => {
                const clients = Array.isArray(res.data) ? res.data : (res.data?.items ?? []);
                sessionStorage.setItem('clients', JSON.stringify(clients));
                commit('SET_CLIENTS', clients);
            })
    },
    getClientsCms({commit}) {
        Api.get(listRoutes.clientCms).then((res) => {
          sessionStorage.setItem("clientsCms", JSON.stringify(res.data));
          commit("SET_CLIENTS_CMS", res.data);
        });
    },
    getClient({commit, state}) {
        const clientId = router.currentRoute.params.id
        commit('SET_CLIENT', state?.clients?.find(x => x.id == clientId))
    },
    getClientMarkets({commit, state}) {
        const clientId = router.currentRoute.params.id;
        if (!state.clientsMarkets[clientId]) {
            PublicAPI.get(listRoutes.clientMarkets.replace(':id', clientId))
                .then(res => res.data)
                .then(data => commit('SET_CLIENT_MARKETS', {
                    client: clientId,
                    market: data
                }))
        }
    }
}
const getters = {
    getClientByName: (state) => (name) => {
        return state.clients ? state.clients.find(client => client.name === name) : null
    },
    getClientById: (state) => (id) => {
        return state.clients ? state.clients.find(client => client.id == id) : null
    },
    getClientByNameUrl: (state) => (nameUrl) => {
        return state.clients ? state.clients.find(client => client.nameUrl === nameUrl) : null
    },
    getClientMarketByCode: (state) => (id, countryCode) => {
        return state.clientsMarkets[id]?.find(market => market.country?.code === countryCode)
    },
    isClientCms: (state) => (clientId) => {
        return !!state.clientsCms?.find(client => client.id == clientId);
    }
}

const clients = {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

export default clients;